import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=a00a1a32&scoped=true&"
import script from "./VideoDetail.vue?vue&type=script&lang=ts&"
export * from "./VideoDetail.vue?vue&type=script&lang=ts&"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=a00a1a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00a1a32",
  null
  
)

export default component.exports